import { IActionSaga } from '../../../../interfaces/actionSaga'
import { IInitialState } from '.'
import { errorState, requestState, successState } from '../../../constants'

export function deleteDocumentary(
  action: IActionSaga,
  draft: IInitialState
): IInitialState {
  switch (action.type) {
    case '@whatWeDo/DELETE_DOCUMENTARY_REQUEST': {
      draft = { ...draft, ...requestState }
      break
    }

    case '@whatWeDo/DELETE_DOCUMENTARY_SUCCESS': {
      draft = {...draft, ...successState, ...action.payload }
      break
    }

    case '@whatWeDo/DELETE_DOCUMENTARY_FAILURE': {
      draft = { ...draft, ...errorState, ...action.payload }
      break
    }

    default:
  }

  return draft
}
